import { render, staticRenderFns } from "./notificationAlert.vue?vue&type=template&id=30bd866a"
import script from "./notificationAlert.vue?vue&type=script&lang=js"
export * from "./notificationAlert.vue?vue&type=script&lang=js"
import style0 from "./notificationAlert.vue?vue&type=style&index=0&id=30bd866a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports